import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import TableSort from '../tableComponents/TableSort'
import TableCsv from '../tableComponents/TableCsv'
import Help from '../Help'
import { formatDateRange, formatDayFilter, formatHourFilter } from "../js/utilityRoutines"
import { variableName } from '../js/constants';

const enspace = String.fromCharCode(8194)

export default function listhrlyTable(props) { 
  const { userParams, tabledata, stnName } = props;
  const [ heads, setHeads ] = useState();
  const [ columnOrder, setColumnOrder ] = useState([]);
  const [ viewWxCodeHelp, setViewWxCodeHelp ] = useState(false);
  const [ viewCldsCodeHelp, setViewCldsCodeHelp ] = useState(false);
  const vars = userParams.variables;
  const dateRange = formatDateRange(userParams);
  const dayFilterText = formatDayFilter(userParams);
  const hourFilterText = formatHourFilter(userParams);
  const titleText = "Hourly Observations<br/ >" + stnName;
  const footerText = dateRange + 
    (dayFilterText ? "<br />" : "") + dayFilterText + "." + 
    (hourFilterText ? enspace : "") + hourFilterText;
 
  useEffect(() => {
    const headRow = []
    const unitsRow = []
    headRow.push(
      {text: "index", id: "index", invisible: true, initSort: true, sortOrder: "asc"},
      {text: "Date", id: "date", altSort: "index"},
      {text: "Hour", id: "hour", component: "th"}
    )
    unitsRow.push(
      {text: " ", id: null, invisible: true},
      {text: " ", id: null},
      {text: "(LST)", id: null}
    )    
    vars.map((v) => {
      headRow.push({text: variableName[v].name, id: v})
      unitsRow.push({text: "(" + variableName[v].units + ")", id: null})
    })
    setHeads([headRow, unitsRow])
    const newColumnOrder = []
    newColumnOrder.push(
      {id: "index", invisible: true},
      {id: "date"},
      {id: "hour"}
    )
    vars.map((v) => {
      newColumnOrder.push(
        {id: v })
    })
    setColumnOrder(newColumnOrder)
  }, [])

  return (
    <Box sx={{my: 1}}>
      {heads && userParams.output === 'html' &&
        <TableSort 
          titleText={titleText} 
          heads={heads}
          columnOrder={columnOrder}
          tableNoSortData={tabledata}
          footerText={footerText}
        />
      }
      {heads && userParams.output === 'csv' &&
        <TableCsv 
          titleText={titleText} 
          heads={heads}
          tabledata={tabledata}
          footerText={footerText}
        />
      }
      <Box sx={{ mt: 1, mb: 1}}>
        <Typography component="span">Help: </Typography>
        <Button 
          variant="outlined" 
          size="small"   
          onClick={() => { setViewWxCodeHelp(!viewWxCodeHelp) }}
        >
          {viewWxCodeHelp ? "Hide" : "View"} present weather code definitions
        </Button>
        <Button 
          variant="outlined" 
          size="small" 
          sx={{ ml: 1}}
          onClick={() => { setViewCldsCodeHelp(!viewCldsCodeHelp) }}
        >
          {viewWxCodeHelp ? "Hide" : "View"} cloud conditions code definitions
        </Button>
      </Box>
      {viewWxCodeHelp &&
        <Help variable="wx" />
      }
      {viewCldsCodeHelp &&
        <Help variable="clds" />
      }
    </Box>
  )
}